import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=6b20f11c&"
import script from "./CompanyInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b20f11c')) {
      api.createRecord('6b20f11c', component.options)
    } else {
      api.reload('6b20f11c', component.options)
    }
    module.hot.accept("./CompanyInfo.vue?vue&type=template&id=6b20f11c&", function () {
      api.rerender('6b20f11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/CompanyInfo.vue"
export default component.exports